<script>
import ChatFile from "./ChatFile.vue"

export default {
    props: ["chat", "curBotId"],
    components: {
        ChatFile,
    },
    methods: {
        getCurrentChatTime(chat_created_on) {
            const currentChatTime = new Date(chat_created_on)

            const currentHours = currentChatTime.getHours()
            const currentMinute = currentChatTime.getMinutes()

            return `${currentHours > 9 ? currentHours : `0${currentHours}`}.${
                currentMinute > 9 ? currentMinute : `0${currentMinute}`
            }`
        },
    },
}
</script>

<template>
    <div
        class="w-100 d-flex flex-column"
        :class="{
            'align-items-end': chat.user_id === curBotId,
            'align-items-start': chat.user_id !== curBotId,
        }"
    >
        <div
            class="mt-1"
            :class="{
                sent: chat.user_id === curBotId,
                received: chat.user_id !== curBotId,
            }"
        >
            <ChatFile
                v-if="chat.media_path"
                class="mb-2"
                :media-path="chat.media_path"
            />

            {{ chat.message }}
        </div>
        <div class="d-flex chat-time">
            {{ getCurrentChatTime(chat.created_on) }}
        </div>
    </div>
</template>

<style>
.sent {
    max-width: 50%;
    background-color: #ff9f43;
    padding: 10px 15px 10px 15px;
    border-radius: 15px 15px 0px 15px;
    color: white;
}

.received {
    max-width: 50%;
    background-color: #bbbbbb;
    padding: 10px 15px 10px 15px;
    border-radius: 15px 15px 15px 0px;
    color: white;
}
</style>
